import { Portal } from '@zenchef/ui'

const BodyPortal = (props) => <Portal {...props} selector='body' />
export default BodyPortal
